/**
 * Capability Registry — advertise active provider capabilities to Host/UI.
 * Never branch on provider identity in host code; use hasCapability / getCapabilities.
 */
import {
  resolveProviderCapabilities,
  createCapabilities,
} from "./ProviderCapabilities";

/**
 * @returns {object} registry
 */
export function createCapabilityRegistry() {
  var current = createCapabilities({
    supportsSeek: false,
    supportsPause: false,
    supportsResume: false,
    supportsPiP: true,
  });
  var providerName = null;

  /**
   * @param {object|null} provider
   * @returns {object} capabilities
   */
  function updateFromProvider(provider) {
    providerName = provider && provider.getName ? provider.getName() : null;
    current = resolveProviderCapabilities(provider);
    return getCapabilities();
  }

  function getCapabilities() {
    return Object.assign({}, current, { providerName: providerName });
  }

  /**
   * @param {string} key e.g. "supportsSeek"
   * @returns {boolean}
   */
  function hasCapability(key) {
    return !!current[key];
  }

  function clear() {
    providerName = null;
    current = createCapabilities({
      supportsSeek: false,
      supportsPause: false,
      supportsResume: false,
      // Unknown / unbound — do not advertise a hard PiP deny. ControlBar and
      // handlePiP treat false as definitive only after a named provider binds.
      supportsPiP: true,
    });
  }

  return {
    updateFromProvider: updateFromProvider,
    getCapabilities: getCapabilities,
    hasCapability: hasCapability,
    clear: clear,
  };
}

export default createCapabilityRegistry;
